import React from 'react';
import { observer } from 'mobx-react-lite';
import NumpadRowItem from './numpadRowItem';
import { userInfoStore } from '../../../store/userInfoStore';

const NumpadRow = observer(() => {
  const { numpadBetAmountList, setBetAmount, betAmount } = userInfoStore;

  return (
    <div className='numpad-number-row'>
      {numpadBetAmountList.map((item) => (
        <NumpadRowItem
          buttonValue={item}
          key={`item-${item}`}
          handleClick={() => setBetAmount(item)}
          betAmount={betAmount}
        />
      ))}
    </div>
  );
});
export default NumpadRow;
